import * as d3 from "d3";
export default class Hull {
    constructor(treeNodeId, name, color) {
        this.treeNodeId = treeNodeId;
        this.name = name;
        this.color = d3.hsl(color);
    }
}
